import React from 'react';
import { ArrowLeftIcon, ArrowRightIcon } from 'lucide-react';
interface ParametersProps {
  onNext: () => void;
  onBack: () => void;
}
export const Parameters: React.FC<ParametersProps> = ({
  onNext,
  onBack
}) => {
  return <div className="mb-20" data-id="element-208">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-209">
        {/* System Selection Card */}
        <div className="bg-white rounded-xl shadow-sm p-6" data-id="element-210">
          <h2 className="text-lg font-semibold text-gray-800 mb-4" data-id="element-211">
            Systemvalg
          </h2>
          <div className="space-y-4" data-id="element-212">
            <div data-id="element-213">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-214">
                System
              </label>
              <div className="flex flex-wrap gap-2" data-id="element-215">
                <div className="px-3 py-1.5 bg-[#E3000F] text-white rounded-full text-sm cursor-pointer" data-id="element-216">
                  QuickTemp Compact Basic
                </div>
                <div className="px-3 py-1.5 bg-gray-100 text-gray-700 rounded-full text-sm cursor-pointer hover:bg-gray-200 transition-colors" data-id="element-217">
                  QuickTemp Premium
                </div>
                <div className="px-3 py-1.5 bg-gray-100 text-gray-700 rounded-full text-sm cursor-pointer hover:bg-gray-200 transition-colors" data-id="element-218">
                  QuickTemp Eco
                </div>
              </div>
            </div>
            <div data-id="element-219">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-220">
                C/C afstand
              </label>
              <div className="flex flex-wrap gap-2" data-id="element-221">
                <div className="px-3 py-1.5 bg-[#E3000F] text-white rounded-full text-sm cursor-pointer" data-id="element-222">
                  150 mm
                </div>
                <div className="px-3 py-1.5 bg-gray-100 text-gray-700 rounded-full text-sm cursor-pointer hover:bg-gray-200 transition-colors" data-id="element-223">
                  100 mm
                </div>
                <div className="px-3 py-1.5 bg-gray-100 text-gray-700 rounded-full text-sm cursor-pointer hover:bg-gray-200 transition-colors" data-id="element-224">
                  200 mm
                </div>
              </div>
            </div>
            <div data-id="element-225">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-226">
                Rør dimension
              </label>
              <div className="flex flex-wrap gap-2" data-id="element-227">
                <div className="px-3 py-1.5 bg-[#E3000F] text-white rounded-full text-sm cursor-pointer" data-id="element-228">
                  16 mm
                </div>
                <div className="px-3 py-1.5 bg-gray-100 text-gray-700 rounded-full text-sm cursor-pointer hover:bg-gray-200 transition-colors" data-id="element-229">
                  20 mm
                </div>
              </div>
            </div>
            <div data-id="element-230">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-231">
                Plade
              </label>
              <div className="flex flex-wrap gap-2" data-id="element-232">
                <div className="px-3 py-1.5 bg-[#E3000F] text-white rounded-full text-sm cursor-pointer" data-id="element-233">
                  Standard
                </div>
                <div className="px-3 py-1.5 bg-gray-100 text-gray-700 rounded-full text-sm cursor-pointer hover:bg-gray-200 transition-colors" data-id="element-234">
                  Alternativ plade
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Dimensioning Card */}
        <div className="bg-white rounded-xl shadow-sm p-6" data-id="element-235">
          <h2 className="text-lg font-semibold text-gray-800 mb-4" data-id="element-236">
            Dimensionering
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-237">
            <div data-id="element-238">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-239">
                ΔT
              </label>
              <div className="flex" data-id="element-240">
                <input type="number" className="flex-1 px-3 py-2 border border-gray-300 rounded-l-md focus:outline-none focus:ring-2 focus:ring-[#E3000F] focus:border-transparent" value="5.0" data-id="element-241" />
                <div className="px-3 py-2 border border-l-0 border-gray-300 rounded-r-md bg-gray-50 text-gray-500 text-sm" data-id="element-242">
                  °C
                </div>
              </div>
            </div>
            <div data-id="element-243">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-244">
                Design T-floor
              </label>
              <div className="flex" data-id="element-245">
                <input type="number" className="flex-1 px-3 py-2 border border-gray-300 rounded-l-md focus:outline-none focus:ring-2 focus:ring-[#E3000F] focus:border-transparent" value="24.0" data-id="element-246" />
                <div className="px-3 py-2 border border-l-0 border-gray-300 rounded-r-md bg-gray-50 text-gray-500 text-sm" data-id="element-247">
                  °C
                </div>
              </div>
            </div>
            <div data-id="element-248">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-249">
                Rumlast
              </label>
              <div className="flex" data-id="element-250">
                <input type="number" className="flex-1 px-3 py-2 border border-gray-300 rounded-l-md focus:outline-none focus:ring-2 focus:ring-[#E3000F] focus:border-transparent" value="50" data-id="element-251" />
                <div className="px-3 py-2 border border-l-0 border-gray-300 rounded-r-md bg-gray-50 text-gray-500 text-sm" data-id="element-252">
                  W/m²
                </div>
              </div>
            </div>
            <div data-id="element-253">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-254">
                Max. kredslængde
              </label>
              <div className="flex" data-id="element-255">
                <input type="number" className="flex-1 px-3 py-2 border border-gray-300 rounded-l-md focus:outline-none focus:ring-2 focus:ring-[#E3000F] focus:border-transparent" value="100" data-id="element-256" />
                <div className="px-3 py-2 border border-l-0 border-gray-300 rounded-r-md bg-gray-50 text-gray-500 text-sm" data-id="element-257">
                  m
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Control Card */}
        <div className="bg-white rounded-xl shadow-sm p-6" data-id="element-258">
          <h2 className="text-lg font-semibold text-gray-800 mb-4" data-id="element-259">Styring</h2>
          <div className="space-y-4" data-id="element-260">
            <div data-id="element-261">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-262">
                Styresystem
              </label>
              <div className="flex flex-wrap gap-2" data-id="element-263">
                <div className="px-3 py-1.5 bg-[#E3000F] text-white rounded-full text-sm cursor-pointer" data-id="element-264">
                  Touchline SL (WiFi)
                </div>
                <div className="px-3 py-1.5 bg-gray-100 text-gray-700 rounded-full text-sm cursor-pointer hover:bg-gray-200 transition-colors" data-id="element-265">
                  Touchline SL (kablet)
                </div>
                <div className="px-3 py-1.5 bg-gray-100 text-gray-700 rounded-full text-sm cursor-pointer hover:bg-gray-200 transition-colors" data-id="element-266">
                  Standard
                </div>
              </div>
            </div>
            <div data-id="element-267">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-268">
                Zoner pr. rum
              </label>
              <select className="w-full px-3 py-2 border border-gray-300 rounded-md bg-white focus:outline-none focus:ring-2 focus:ring-[#E3000F] focus:border-transparent" data-id="element-269">
                <option data-id="element-270">1</option>
                <option data-id="element-271">2</option>
                <option data-id="element-272">3</option>
              </select>
            </div>
          </div>
        </div>
        {/* Pipe Selection Card */}
        <div className="bg-white rounded-xl shadow-sm p-6" data-id="element-273">
          <h2 className="text-lg font-semibold text-gray-800 mb-4" data-id="element-274">Rørvalg</h2>
          <div data-id="element-275">
            <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-276">
              Rør dimension
            </label>
            <select className="w-full px-3 py-2 border border-gray-300 rounded-md bg-white focus:outline-none focus:ring-2 focus:ring-[#E3000F] focus:border-transparent" data-id="element-277">
              <option data-id="element-278">16 mm</option>
              <option data-id="element-279">20 mm</option>
              <option data-id="element-280">25 mm</option>
            </select>
          </div>
        </div>
      </div>
      <div className="flex justify-between" data-id="element-281">
        <button onClick={onBack} className="flex items-center px-4 py-2 text-gray-600 hover:text-gray-800 transition-colors" data-id="element-282">
          <ArrowLeftIcon className="w-4 h-4 mr-2" data-id="element-283" />
          Tilbage
        </button>
        <button onClick={onNext} className="flex items-center px-4 py-2 bg-[#E3000F] text-white rounded-md hover:bg-red-700 transition-colors" data-id="element-284">
          Beregn flow
          <ArrowRightIcon className="w-4 h-4 ml-2" data-id="element-285" />
        </button>
      </div>
    </div>;
};